<template>
<v-dialog
    v-model="dialog"
    max-width="960"
>
    <v-card>
        <v-card-title>Review Automated Messages</v-card-title>

        <v-card-text>
            
            <p><b>Take a Moment To Review Your Message(s)</b></p>

            <p>
                It's a good practice to regularly review your automated messages to ensure they are still accurate, relevant, and useful. Please take a moment to carefully check the automated messages currently set up and confirm whether they should continue being sent.
            </p>

            <m-auto-message-template-search-table
                ref="autoMessageTable"
                :organization_id="$rc.$state.profile.employee_account.organization_id"
                :show_column_type="false"
                :show_list_label="false"
                :show_column_delay="false"
                :show_column_params="false"
                :show_column_notes="false"
                :show_manual_warning="false"
                :show_icon_bar="false"
                :show_auto_only="true"
            />

            <p style="margin-top: 20px"><b>Actions</b></p>

            <v-checkbox
                label="I have reviewed my message(s) and am happy with the message, its settings and any attachments"
                v-model="test_acknowledgement"
                style="margin-right: 15px; margin-bottom: -25px"
            /> 
            

            <m-legal-checkbox-agreement
                type="auto-message-attestation"
                :organization_id="$rc.$state.profile.employee_account.organization_id"
                v-model="consent_acknowledgement"
            />
        </v-card-text>

        <v-card-actions>

            <v-btn
                text
                @click="onCancel"
            >
                Stop All Messages
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!consent_acknowledgement || !test_acknowledgement"
            >
                Continue All Messages
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            test_acknowledgement: false,
            consent_acknowledgement: false,
        }
    },

    methods: {

        showDialog()
        {
            this.dialog = true;
            this.test_acknowledgement = false;
            this.consent_acknowledgement = false;
        },

        onOk()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/legal/auto-messages-in-need-of-review/sign-all',
            
                'params' : {
                        'organization_id': this.$rc.$state.profile.employee_account.organization_id
                    },
            
                'on_success': (data) => {
                        this.dialog = false;
                    },
            
                'on_error': 'Unable to stop all automated messages',
            });
        },

        onCancel()
        {
            this.$rc.confirm({
                'title': 'Confirm Stop All Automated Messages',
                'body': 'All automated messages currently in automatic mode will be placed in manual mode.\n\nAre you sure that you want to make this change?',
                'btn_text_ok': 'Stop All Messages',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doStopAllMessages();
                },
            });
        },

        doStopAllMessages()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/legal/auto-messages-in-need-of-review/all-to-manual-mode',
            
                'params' : {
                        'organization_id': this.$rc.$state.profile.employee_account.organization_id
                    },
            
                'on_success': (data) => {
                        this.dialog = false;
                    },
            
                'on_error': 'Unable to stop all automated messages',
            });
        },

    },
}
</script>

<style lang="scss" scoped>
</style>